// Copyright (c) 2021 Deere & Company

import t from 'tcomb';

const PinTransferDataRequest = t.struct({
    pin: t.Any,
    dealerIds: t.Any,
    status: t.Any,
}, {
    name: 'pinTransferDataRequest',
    strict: false,
});

export const getDefaultState = () => new PinTransferDataRequest({
    pin: null,
    dealerIds: null,
    status: null,
});

export default PinTransferDataRequest;
